import { getAntdTheme as getGeneratedAntdTheme } from '@env0/ui-theme/antd';
import type { ThemeConfig } from 'antd';
import type { Env0Theme } from './themes.constants';

export const getAntdTheme = (theme: Env0Theme): ThemeConfig => getGeneratedAntdTheme(theme.mode);
